// Libraries
import _debounce from 'lodash/debounce'

// Shared
import { getPrices, getPrice } from 'shop-components/api/price'
import { cleanConfiguration } from '../../utils/variations'

let ids = []

const pricesRequest = ({ cartId, dispatch }) => {
  dispatch({
    type: 'PRODUCT_PRICES_FETCH_START'
  })

  getPrices({ ids, cartId })
    .then(({ data: { data } }) => {
      const prices = data.map(({ attributes }) => attributes)

      dispatch({ type: 'PRODUCT_PRICES_FETCH_SUCCESS', payload: { records: prices } })
    })
    .catch(() => {
      dispatch({
        type: 'PRODUCT_PRICES_FETCH_ERROR'
      })
    })

  ids = []
}

const priceRequest = ({ id, cartId, configuration, dispatch }) => {
  dispatch({
    type: 'PRODUCT_PRICES_FETCH_START'
  })

  getPrice({ id, configuration: cleanConfiguration(configuration), cartId })
    .then(({ data: { data } }) => {
      const prices = data.map(({ attributes }) => attributes)

      dispatch({ type: 'PRODUCT_PRICES_FETCH_SUCCESS', payload: { records: prices } })
    })
    .catch(() => {
      dispatch({
        type: 'PRODUCT_PRICES_FETCH_ERROR'
      })
    })
}

const fetchPricesDebounced = _debounce(pricesRequest, 50)

const fetchPriceDebounced = _debounce(priceRequest, 50)

export const fetchPrices = ({ id, cartId }) => (dispatch) => {
  if (!ids.includes(id)) {
    ids.push(id)
  }

  return fetchPricesDebounced({ cartId, dispatch })
}

export const fetchPrice = ({ id, cartId, configuration }) => (dispatch) => {
  return fetchPriceDebounced({ id, cartId, configuration, dispatch })
}
